import { Language } from "./language";

export const STUDENTLANGUAGES: Language[] = [
    {id: 2, name: "English" },
    {id: 1, name: "French" },
    {id: 3, name: "Dutch" },
    {id: 4, name: "Spanish" }
]